import React from "react";
import {Skeleton, Card, ListItem, ListItemAvatar, ListItemText} from "@mui/material";

const DashboardAuthenticationCardSkeletonComponent = (props) => {

    const {breakpoints} = props;

    return (
        <Card sx={{mt: 1.5, mb: 1.5}}>
            <ListItem>
                <ListItemAvatar>
                    <Skeleton variant="circular" sx={{height: "50px", width: "50px", backgroundColor: "rgb(108 139 222 / 30%)"}} />                     
                </ListItemAvatar>

                <ListItemText 
                    primary={
                        <Skeleton variant="text" sx={{mt: "-6px !important", borderRadius: "4px", mb: "3px", height: "24px", backgroundColor: "rgb(108 139 222 / 30%)"}} />                     
                    }
                    secondary={
                        <Skeleton variant="text" sx={{mt: "-6px !important", borderRadius: "4px", mb: "3px", height: "24px", backgroundColor: "rgb(108 139 222 / 30%)"}} />                     
                    }
                />
            </ListItem>

            <Skeleton variant="text" sx={{ml: "auto !important", mr: "15px !important", mt: "-6px !important", borderRadius: "4px", mb: "3px", height: "24px", width: "40%", backgroundColor: "rgb(108 139 222 / 30%)"}} />                     
        </Card>
    )
}

export default DashboardAuthenticationCardSkeletonComponent